/** Small uppercase section label + divider, shared across the "New booking"
 *  form sections (Workshop / Customer / Payment). */
export function CreateBookingSectionHeader({
  children,
  hint,
}: {
  children: React.ReactNode;
  hint?: string;
}) {
  return (
    <div className="mb-2 flex items-baseline justify-between gap-3 border-b border-stone-200 pb-1.5 dark:border-stone-700">
      <h3 className="text-xs font-bold uppercase tracking-wide text-stone-700 dark:text-stone-300">
        {children}
      </h3>
      {hint && <span className="text-xs text-stone-400">{hint}</span>}
    </div>
  );
}
